import React from 'react';
import { ActionButton } from './Themed.js';
import './ModalMessage.css';
import { t } from '../locales';

export default class ModalMessage extends React.PureComponent {
  render() {
    const { text, onConfirmClick } = this.props;

    return (
      <React.Fragment>
        <div className="modal-message-backdrop" />
        <div className="modal-message-card">
          <div className="modal-message-text">{text}</div>
          <ActionButton
            className="modal-message-button"
            onClick={onConfirmClick}
          >
            { t('ok') }
          </ActionButton>
        </div>
      </React.Fragment>
    );
  }
}
